import React from 'react';
import {
  CatalogUnifiedSearchScreenProps,
  OrderGuideUnifiedSearchScreenProps,
  SearchEntryPoint,
  UnifiedSearchScreenComponentProps,
} from './types';
import { SearchScreenComponent } from './search-screen';
import { UnifiedSearchDesktop } from './unified-search-desktop';
import { useLayoutContext } from '@/contexts/layout-context';

const UnifiedSearchScreenComponent: React.FC<
  UnifiedSearchScreenComponentProps
> = ({ category, navigation, searchEntryPoint }) => {
  const { isSmallLayout, isSmallTabletLayout } = useLayoutContext();

  // Use mobile layout for small screens and small tablets
  if (isSmallLayout || isSmallTabletLayout) {
    return (
      <SearchScreenComponent
        category={category}
        navigation={navigation}
        searchEntryPoint={searchEntryPoint}
        showCategories
      />
    );
  }

  return (
    <UnifiedSearchDesktop
      category={category}
      navigation={navigation}
      searchEntryPoint={searchEntryPoint}
    />
  );
};

// Order Guide stack component
export const OrderGuideUnifiedSearchScreen: React.FC<
  OrderGuideUnifiedSearchScreenProps
> = ({ navigation, route }) => {
  const { category } = route.params || {};

  return (
    <UnifiedSearchScreenComponent
      category={category}
      navigation={navigation}
      searchEntryPoint={SearchEntryPoint.ORDER_GUIDE}
    />
  );
};

// Catalog stack component
export const CatalogUnifiedSearchScreen: React.FC<
  CatalogUnifiedSearchScreenProps
> = ({ navigation, route }) => {
  const { category } = route.params || {};
  return (
    <UnifiedSearchScreenComponent
      category={category}
      navigation={navigation}
      searchEntryPoint={SearchEntryPoint.CATALOG}
    />
  );
};
